<template>
	<div class="brand-fluid" v-if="typeData && typeData.length > 0">
		<el-row>
			<el-col v-for="(item, index) in typeData" :key="item.id" :xs="24" :sm="8">
				<router-link :to="`/category?type_id=${item.id}`" class="brand-link scale">
					<img :src="item.pic" alt="" />
				</router-link>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import {index_goods_type_api} from "@/api/index"
	export default {
		data() {
			return {
				typeData:[]
			};
		},
		
		methods:{
			async getGoodsType() {
				try {
					let param = {
						is_page:1
					}
					const res = await index_goods_type_api(param);
					if (res && res.data.code == 1) {
						this.typeData = res.data.data;
						console.log(this.typeData,'this.typeData')
					}
				} catch (error) {
					console.error('获取商品数据失败', error);
				}
			},
		},
		mounted() {
			this.getGoodsType()
		}
	}
</script>
